import React from "react";
import styled from "@emotion/styled";
import { connect } from "react-redux";

const MainHeader = styled.div`
  padding-top: ${props => props.paddingTop};
  text-align: center;
  background-color: #ffffff;
  border-radius: 0px 0px 30px 30px;
  position: relative;
  padding-bottom: 50px;
`;

const Header = styled.div`
  font-size: 24px;
  line-height: 1.63;
  color: #1f2021;
  margin-top: 15px;
  margin-bottom: 22px;
`;

const P = styled.div`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.25;
  letter-spacing: normal;
  text-align: center;
  color: #777984;
  max-width: ${props => props.maxWidth};
  margin: 0 auto;

  @media (max-width: 800px) {
    max-width: 90%;
    font-size: 15px;
    line-height: 2;
  }
`;

const OrderSpan = styled.span`
  font-weight: 500;
  color: #1f2021;
`;

const OrderSpanBG = styled(OrderSpan)`
  background-color: rgba(119, 121, 132, 0.1);
  padding: 8px;
  border-radius: 5px;
`;

const Br = styled.br`
  @media (max-width: 800px) {
    display: none;
  }
`;

const SellCompleteHeader = ({
  checkoutOrdersSell,
  checkoutOrdersSellID,
  bannersList
}) => {
  return (
    <MainHeader paddingTop={bannersList.length > 0 ? "110px" : "200px"}>
      <img
        src="https://cdn.cardcash.com/website/ui/elements/receipt_bird2.svg"
        alt="icon"
      />
      <Header>
        {`Congratulations, ${
          checkoutOrdersSell[checkoutOrdersSellID]?.customerDetails.name.split(
            " "
          )[0]
        }`}
        !
      </Header>
      <P
        maxWidth={
          checkoutOrdersSell[checkoutOrdersSellID].type !== "ecode"
            ? "750px"
            : "525px"
        }
      >
        Your order
        <OrderSpan>
          &nbsp;{checkoutOrdersSell[checkoutOrdersSellID]?.orderId}&nbsp;
        </OrderSpan>
        is confirmed.
        {checkoutOrdersSell[checkoutOrdersSellID].type !== "ecode" ? (
          <>
            &nbsp;Please note that&nbsp;
            <OrderSpanBG>
              {checkoutOrdersSell[checkoutOrdersSellID].cards.length > 1
                ? "all cards in this order "
                : "this card "}
              must be mailed in.
              <Br />
            </OrderSpanBG>
          </>
        ) : (
          ""
        )}
        &nbsp;We’ll verify the card balance and then the payment will be
        initiated within two business days.
      </P>
    </MainHeader>
  );
};

export default connect(state => ({
  checkoutOrdersSell: state.checkoutOrdersSell,
  bannersList: state.banners.bannersList
}))(SellCompleteHeader);
